import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup popup--error"
}
const _hoisted_2 = { class: "popup__content" }
const _hoisted_3 = { class: "popup__header" }
const _hoisted_4 = ["innerHTML"]

import { } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { ErrorMessageStore } from '@/stores/errorMessage';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  setup(__props) {

    /* imports */
    const { t } = useI18n();

    const errorMessageStore = ErrorMessageStore();


    const close = () => {
        errorMessageStore.close();
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "popup" }, {
    default: _withCtx(() => [
      (_unref(errorMessageStore).state.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('error.heading')), 1),
              _createElementVNode("p", {
                class: "popup__text",
                innerHTML: _unref(errorMessageStore).state.message
              }, null, 8, _hoisted_4),
              _createElementVNode("div", { class: "popup__buttons" }, [
                _createElementVNode("button", {
                  class: "btn",
                  onClick: close
                }, "Stäng")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})